import React, { useContext, useEffect, useRef } from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import { disableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock';

import ModalContext from '../modal/ModalContext';

import './CenterModal.module.css';

const CenterModal = ({ children, id, onClose, noPadding, width }) => {
  const { t } = useTranslation();
  const { showModal, hideModal } = useContext(ModalContext);
  const containerRef = useRef(null);

  const content = () => (
    <div
      styleName={classnames('modal', { noPadding })}
      ref={containerRef}
      aria-modal="true"
      role="dialog"
    >
      <div styleName="content" style={{ width: width || '80vh' }}>
        {children}
      </div>
      <button
        type="button"
        aria-label={t('Close')}
        styleName="close"
        onClick={() => {
          hideModal();
          if (onClose) {
            onClose();
          }
        }}
      >
        &#215;
      </button>
    </div>
  );

  useEffect(
    () => {
      disableBodyScroll(containerRef.current);
      showModal(content, id, {}, 'blind', onClose);

      return () => {
        clearAllBodyScrollLocks();
        hideModal();
      };
    },
    [id]
  );

  return null;
};

export default CenterModal;
